<template>
  <Aggregate
    title="Demand"
    v-model="computedValue"
    :ItemConstructor="CaseModel.DemandProject"
    :headers="[
      { text: 'Name', value: 'name' },
      { text: 'Active', value: 'active', width: 1 },
    ]"
    :cardProps="{ flat: true, class: [] }"
    toolbar-dense
    @change="$emit('change')"
  >
    <template #[`item.active`]="{ item }">
      <v-switch v-model="item.active" dense @change="$emit('change')"></v-switch>
    </template>
    <template #default="{ item }">
      <InputGeo
        v-model="item.coordinates"
        label="Coordinates"
        map-height="150"
        nullable
        switch-text="Use Demand coordinates"
        @change="$emit('change')"
      />
      <v-switch
        v-model="item.scale"
        :label="schema.scale.title"
        :hint="schema.scale.tooltip"
        @change="$emit('change')"
      ></v-switch>
      <template v-if="item.scale">
        <InputYearly
          v-model="item.scale_peak"
          label="Peak Load"
          suffix="MW"
          :num_years="num_years"
          :year_start="year_start"
        />
        <InputYearly
          v-model="item.scale_annual"
          label="Annual Load"
          suffix="GWh"
          :num_years="num_years"
          :year_start="year_start"
        />
      </template>
      <InputYearlyProfile
        v-model="item.profile"
        :label="schema.profile.title"
        :suffix="schema.profile.unit"
        :num_years="num_years"
        :profile-type="schema.profile.profileType"
        :multi-year-upload="true"
        object-value
        @change="$emit('change')"
      ></InputYearlyProfile>
      <InputYearlyProfile
        v-model="item.voll"
        :label="schema.voll.title"
        :suffix="schema.voll.unit"
        :num_years="num_years"
        :year_start="year_start"
        fill
        :fill-value="0"
        object-value
        items-type="constant"
        @change="$emit('change')"
      ></InputYearlyProfile>
      <v-expansion-panels tile multiple accordion flat class="mx-0 px-0">
        <v-expansion-panel>
          <v-expansion-panel-header class="text-subtitle-1 font-weight-medium"
            >Services
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <SystemProjectServices
              v-model="item.services"
              :year_start="year_start"
              :num_years="num_years"
              resource-type="demand"
              @change="$emit('change')"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </Aggregate>
</template>

<script>
import { CaseModel, schemas } from "data-dictionary";

export default {
  name: "SystemProjectDemand",
  components: {
    Aggregate: () => import("@/components/Aggregate.vue"),
    InputGeo: () => import("@/components/InputGeo.vue"),
    InputYearlyProfile: () => import("@/components/InputYearlyProfile.vue"),
    InputYearly: () => import("@/components/InputYearly.vue"),
    SystemProjectServices: () => import("@/components/SystemProjectServices.vue"),
  },
  mixins: [],
  props: {
    value: { type: Array, required: true },
    year_start: { type: Number, required: true },
    num_years: { type: Number, required: true },
  },
  data() {
    return {
      CaseModel,
      schema: {
        ...schemas.find((v) => v.$id === "demand_project.schema.json").properties,
      },
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change");
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
